export default class Utils {
  

  static arrayToCsvString(arr) {
    var str = ''
    arr.forEach((arr2) => {
      str += arr2.map((el) => {
        return `"${('' + el).replace(/"/g, '\\"')}"`
      }).join(',') + '\n'
    })
    return str
  }

  static makeCancelablePromise(promise) {
    let hasCanceled_ = false
    const wrappedPromise = new Promise((resolve, reject) => {
      promise.then((val) =>
        hasCanceled_ ? reject({isCanceled: true}) : resolve(val)
      )
      promise.catch((error) =>
        hasCanceled_ ? reject({isCanceled: true}) : reject(error)
      )
    })
    return {
      promise: wrappedPromise,
      cancel() {
        hasCanceled_ = true
      }
    }
  }

  static uploadWithProgress(url, options, onProgress) {
    // console.log(url, options, onProgress)
    return new Promise((resolve, reject) => {
      const req = new XMLHttpRequest()
      req.open(options.method, url)
      if (options.headers) {
        Object.keys(options.headers).forEach(key => {
          req.setRequestHeader(key, options.headers[key])
        })
      }
      if (onProgress) {
        req.upload.addEventListener('progress', event => {
          onProgress({
            loaded: event.loaded,
            total: event.total,
            percent: event.loaded / event.total * 100
          })
        })
      }
      req.addEventListener('load', () => {
        if (/^2/.test(req.status)) {
          resolve(true)
        } else {
          reject(req.responseText)
        }
      })
      req.send(options.body)
    })
  }
  
}